export { ReviewClaimSubmissionPage as default } from './review-claim-page'
